import { OneClickPurchaseInfo } from './one-click-purchase-info';
import {ShopWindowItem} from './shop-window-item';
import {ShopWindowMessage} from './shop-window-message';

export class ShopWindow {
  sellerId: string;
  shopWindowItems: Array<ShopWindowItem>;
  shopWindowMessage: ShopWindowMessage;
  errors: Array<string>;
  invalidCS: boolean;
  validatedMitigation: boolean;
  oneClickPurchaseInfo: OneClickPurchaseInfo;
  typeSpecialMessage: string;
  trustConsultationData: any;
  constructor(shopWindowData?: any) {
    if(shopWindowData) {
      this.sellerId = shopWindowData.sellerId;
      this.shopWindowItems = this.getShopWindowItem(shopWindowData.shopWindowItems);
      this.shopWindowMessage = new ShopWindowMessage (shopWindowData.shopWindowMessage);
      this.invalidCS = shopWindowData.invalidCS;
      this.validatedMitigation = shopWindowData.validatedMitigation;
      this.oneClickPurchaseInfo = shopWindowData.oneClickPurchaseInfo;
      this.typeSpecialMessage = shopWindowData.typeSpecialMessage;
      this.trustConsultationData = shopWindowData.trustConsultationData;
    }
  }

  getShopWindowItem(shopWindowItemsData: Array<any>): Array<ShopWindowItem> {
    const IS_NEW = shopWindowItemsData.some(shopWindowItem => shopWindowItem.product?.identifier?.includes("novo") || shopWindowItem.product?.identifier?.includes("assinatura-120") || shopWindowItem.product?.identifier?.includes("assinatura-270") || shopWindowItem.product?.identifier?.includes("assinatura-variavel"));
    const WAS_APPLY_DISCOUNT =  shopWindowItemsData.some(shopWindowItemData => shopWindowItemData?.appliedDiscounts?.filter(discount => discount.type !== "EXTRA_BALANCE").length > 0);
    if(WAS_APPLY_DISCOUNT && !IS_NEW) {
      shopWindowItemsData = this.removePreferred(shopWindowItemsData);
    }
    let shopWindowItems: Array<ShopWindowItem> = new Array<ShopWindowItem>();
    shopWindowItemsData.forEach(shopWindowItemData => {
      shopWindowItems.push(new ShopWindowItem(shopWindowItemData));
    });
    
    return shopWindowItems;
  }

  removePreferred(shopWindowItemsData: Array<any>): Array<any> {
    return shopWindowItemsData.map(shopWindowItemData => {
      shopWindowItemData.preferred = false;
      return shopWindowItemData;
    });
  }
}
